import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../../Dialogos/DialogView'
import DeleteIcon from '@material-ui/icons/Delete'
import { DialogConfirmacionContent } from '../../../../Dialogos/DialogConfirmacionContent'

function DeleteTransferencia (props) {
  const { handleDelete } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const handleSubmit = () => {
    handleDelete()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          confirmCallback={handleSubmit}
          cancelCallback={handleClose}
          content={<DialogConfirmacionContent
            message='La transferencia entre exportadores seleccionada será eliminada'
          />
          }
        />
      </Dialog>
      <Tooltip title={'Eliminar'}>
        <IconButton onClick={handleOpen}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default DeleteTransferencia
